import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';

function App() {

	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
	

    const [productData, setProductData] = useState([]);
    const [clientData, setClientData] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
  	const [selectedClent, setSelectedOption] = useState('');
	const [qty, setQty] = useState('');
	const [selectedProduct, setProduct] = useState('');
	const [cartError, setCartError] = useState(false);
	const [error, setError] = useState('');
	const [cartItems, setCartItems] = useState([]);
	const [crates, setCrates] = useState(0);
	const [weight, setWeight] = useState(0);
	const [counts, setCounts] = useState(0);
	const [orderError, setOrderError] = useState(false);
	const [errorClient, setClientError] = useState('');
	const [routes, setRoutes] = useState('');
	const [zones, setZones] = useState('');
	const [dealerData, setDealerData] = useState('');
	const [inputData, setinputData] = useState('');
	const [filterDealer, setFilterDealer] = useState('');
	const [address, setAddress] = useState([]);
	const [dispatchAddress, setDispatchAddress] = useState(null);

	const [inputType, setinputType] = useState('crates');
	const [invType, setInvType] = useState('order');
	const [shipping, setShipping] = useState(null);
	const [shippingAddress, setShippingAddress] = useState(null);
	const today = new Date().toISOString().split('T')[0];
	const [selectedProductName, setProductName] = useState('');
	const inputRef = useRef(null);
	
	useEffect(() => {
		const product = productData?.filter(products => products.id === selectedProduct);
		setProductName(product[0]?.productName);
	},[selectedProduct]);

	//console.log(cartItems);

	function triggerError() {
		setCartError(true);
		setTimeout(() => {
			setCartError(false);
			setError('');
		}, 2000);
	}

	function triggerClientError() {
		setOrderError(true);
		setTimeout(() => {
			setOrderError(false);
			setClientError('');
		}, 2000);
	}

	const filerDealer = () => {
		const dealerInfo = dealerData && dealerData?.filter(dealer => dealer.id === selectedClent);
		console.log(dealerInfo);
		if(dealerInfo[0]){
			setinputData((prevData) => ({
				...prevData,
				['route']: dealerInfo[0].routeId,
				['location']: dealerInfo[0].locationId,
				['zone']: dealerInfo[0].zone,
				['dealerName']: dealerInfo[0].dealer,
		  	}));
		}
		//console.log(dealerInfo);
	};
	
	useEffect(() => {
		filerDealer();
	},[selectedClent]);

	const filteredOptions = dealerData && dealerData?.filter(option =>
		option.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
		option.dealer.toLowerCase().includes(searchTerm.toLowerCase())
	);

	//const selectedClentData = clientData?.filter(client => client.id === selectedClent);
	
	const handleSelect = (option) => {
		setSelectedOption(option);
		const address = dealerData?.filter(data => data.id === option);
		//console.log(address);
		setShipping(address[0]?.shipping);
	};

	//console.log(shipping);

	const getCart = () => {
		const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
		setCartItems(cartItems);
		let crates = 0;
		let ltr = 0;
		let count = 0;
	
		cartItems.forEach(item => {
			const qty = parseFloat(item.qty);
			const crate = parseFloat(item.crates);
			const weight = parseFloat(item.weight);
	
			crates += qty;
			ltr += ((qty * crate * weight)/1000);
			count +=(qty * crate);
		});
		
		setCrates(crates);
		setWeight(ltr);
		setCounts(count);
	};
	



    const getClient = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/clients/clients/', {userId: userID}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

			if(response.data.status === 'success'){
				setClientData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	const getZone = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/zone/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setZones(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

	const getProducts = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/products/all-product/', {userId: userID}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

			if(response.data.status === 'success'){
				setProductData(response.data.data);
				sessionStorage.setItem('cartItems', JSON.stringify([]));
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const getRoutes = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/routes/view/',{}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			if(response.data.status === 'success'){
				setRoutes(response.data.routes);
			}
	
			
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const getDealerData = async () => {
		try {
			const response = await axios.get('https://api.trucoo.in/dealers/view/', {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				setDealerData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const getAddress = async () => {
			try {
				const response = await axios.get('https://api.trucoo.in/address/get/', {
					headers: {
						'Content-Type': 'application/json',
						'X-API-KEY': 'erpTrucoo'
					}
				});
				//console.log(response.data);
				if(response.data.status === 'success'){
					setAddress(response.data.data);
				}
			} catch (error) {
				console.error("Error:", error.response || error.message);
			}
		};


	useEffect(() => {
		getClient();
		getProducts();
		getCart();
		getDealerData();
		getRoutes();
		getZone();
		getAddress();
		setinputData((prevData) => ({
          ...prevData,
		  ['date']: today
        }));
	},[]);

	const newData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
          ...prevData,
          [name]: value,
		  ['userId']: userID
        }));
    };

	const changeQty = (e) => {
		const qtys = e.target.value;
		setQty(qtys);
	};



	const changeQtyBtn = (calc) => {
		if(calc === 'plus'){
			if(qty === '' || isNaN(qty)){
				setQty(1);
			}else{
				setQty(parseFloat(qty)+1);
			}
		}else{
			if(qty === 0){
				setQty(qty);
			}else{
				setQty(parseFloat(qty)-1);
			}
		}
	};


	const focusAndSelectInput = () => {
    	if (inputRef.current) {
      		inputRef.current.focus();
      		inputRef.current.select();
    	}
  	};

	const addCart = () => {

		if(selectedProduct === '' || !selectedProduct){
			setError('Please select product');
			triggerError();
		}else{

			if(qty === 0 || !qty){
				setError('Please select quantity atleast 1');
				triggerError();
			}else{

				const existingCartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
				const existingItemIndex = existingCartItems.findIndex(item => item.product === selectedProduct);

				if (existingItemIndex !== -1) {
					const crates = parseFloat(existingCartItems[existingItemIndex].crates);
					const weight = parseFloat(existingCartItems[existingItemIndex].weight);
					const onecrate = (crates * weight) / 1000;
					let qtyin = 0;
					if(inputType === 'ltr'){
						qtyin = qty / onecrate;
					}else{
						qtyin = qty;
					}
					const newQty = parseFloat(existingCartItems[existingItemIndex].qty) + parseFloat(qtyin);
					if (!isNaN(newQty) && newQty > 0) {
						existingCartItems[existingItemIndex].qty = newQty;
					} else {
						console.log("Invalid quantity");
					}
				}else{

					const product = productData.find((product) => product.id === selectedProduct);
					const price = product ? product.productPrice : null;
					const type = product ? product.type : null;
					const name = product ? product.productName : null;
					const hsn = product ? product.productHsn : null;
					const productWeight = product ? product.productWeight : 0;
					const productUnit = product ? product.unit : null;
					const productGst = product ? product.productGst : null;
					const crates = product ? product.grade : 0;
					const oneCrate = (parseFloat(crates) * parseFloat(productWeight)) / 1000;

					let qtyin = 0;
					if(inputType === 'ltr'){
						qtyin =  qty /oneCrate;
					}else{
						qtyin = qty;
					}

					const newItem = {
						product: selectedProduct,
						qty: qtyin,
						price: price,
						name: name,
						hsn: hsn,
						weight: productWeight,
						unit: productUnit,
						gst: productGst,
						crates: crates,
						itemType: type,
						type: inputType === 'crates' ? 'Crates' : 'Litre',
						code: product ? product.productCode : null,
					};

					existingCartItems.push(newItem);
				}

				sessionStorage.setItem('cartItems', JSON.stringify(existingCartItems));
				getCart();
			}
		}
		setQty('');
		setProduct('');
		setProductName('');
		focusAndSelectInput();
	};

	//console.log(shippingAddress);

	const removeItem = (id) => {
		const updatedCartItems = cartItems.filter(item => item.product !== id);
		sessionStorage.setItem('cartItems', JSON.stringify(updatedCartItems));
		getCart();
	};

	const placeOrder = async () => {

	  	if(cartItems.length === 0){
			setClientError('Please Add Items!');
			triggerClientError();
	  	}else if (selectedClent === '' || !selectedClent) {
		  	setClientError('Select Dealer!');
		  	triggerClientError();
		}else if (shippingAddress === null || !shippingAddress) {
			setClientError('Select Shipping Address!');
			triggerClientError();
		} else if(!dispatchAddress){
			setClientError('Select Dispatch Address!');
			triggerClientError();
		}else{

			const orderData = {
				userId: userID,
				dealerId: selectedClent,
				clientId: null,
				crates: crates,
				weight: weight,
				items: cartItems,
				vNum: inputData?.vNum || '',
				evNum: inputData?.evNum || '',
				remarks: inputData?.remarks || '',
				type: 'challan',
				shipping: shippingAddress,
				date: inputData?.date || today,
				shipFrom: dispatchAddress,
				dealerName: inputData?.dealerName || ''
			}
			
		  	try {
				const response = await axios.post('https://api.trucoo.in/orders/new-order/', orderData, {
					headers: {
						'Content-Type': 'application/json',
						'X-API-KEY': 'erpTrucoo'
					}
				});

				//console.log(response.data);

				if(response.data.status === 'success'){
					sessionStorage.removeItem('cartItems');
					getCart();
					setQty('');
					setSelectedOption('');
					setSearchTerm('');
					setProduct('');
					setWeight('');
					setCrates('');
					setShippingAddress(null);
					setShipping(null);
					setinputData('');
					setRoutes('');
					alert('Order Placed');
					window.location.reload();
				}
		  	} catch (error) {
				console.error(error);
			}
		}
	};

	
	console.log(cartItems);

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					
					<div class="row">
                       
						<div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>New Challan</h4>
								    <hr class="my-15" />

								    <div class="row">
										<div class="col-md-12 mt-2 mb-3">
											<div class="form-group">
												<label class="form-label">Select Date</label>
												<div class="input-group" >
													{/* <button class={`btn btn-md ${invType === 'invoice' ? 'btn-primary w-25' : 'btn-light w-25'} `} onClick={()=> setInvType('order')}>Invoice</button>
													<button class={`btn btn-md ${invType === 'dc' ? 'btn-primary w-25' : 'btn-light w-25'} `} onClick={()=> setInvType('challan')}>DC</button> */}
													<input type="date" class="form-control w-50" name="date" value={inputData.date} onChange={(e)=>newData(e)} required />
												</div>
											</div>
										</div>

										<div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Select Dealer</label>
									            <div className="select-container">

        												<div className="dropdown" style={{ maxHeight: '300px', overflowY: 'auto', marginTop: '5px', border: '1px solid #333', padding: '5px', borderRadius: '10px' }}>
          													<input type="text" className="form-control mt-2" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ padding: '5px', width: '100%', border: '1px solid #6c6c6c' }} />
          													<div className="options" style={{ maxHeight: '200px', overflowY: 'auto' }}>
            													{filteredOptions.length === 0 ? (
              														<div className="no-options">No matching options</div>
            													) : (
              														filteredOptions.map((option, index) => (
                														<button key={index} className={option.id === selectedClent ? 'form-control mt-2 bg-primary' : 'form-control mt-2'} onClick={() => handleSelect(option.id)} >
                  															{option.dealer} 
                														</button>
              														))
            													)}
          													</div>
        												</div>
    											</div>
									        </div>
								        </div>

										<div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Zone</label>
												<select class="form-select" name="zone" value={inputData.zone} onChange={(e)=>newData(e)}>
													<option value="">Select a zone</option>
													{zones && zones?.map((data, index)=>
														<option key={index} value={data.id}>{data.zone}</option>
													)}
												</select>
									        </div>
										</div>

										<div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Route</label>
												<select class="form-select" name="route" value={inputData.route} onChange={(e)=>newData(e)}>
													<option value="">Select a route</option>
													{routes && routes?.map((route, index)=>
														<option key={index} value={route.id}>{route.route}</option>
													)}
												</select>
									        </div>
										</div>

										<div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Place</label>
												<select class="form-select" name="location" value={inputData.location} onChange={(e)=>newData(e)}>
													<option value="">Select a route</option>
													{inputData.route && routes && routes?.find(loc => loc.id === inputData.route)?.locations?.map((location, index)=>
														<option key={index} value={location.id}>{location.location}</option>
													)}
												</select>
									        </div>
										</div>

										{shipping?.length > 0 && 
											<div class="form-group">
                    							<label>Select Shipping Address</label>
                    							{shipping?.map(adrs => 
                    								<div for={adrs.id} style={{padding: '10px', margin: '10px 0px', border: `${shippingAddress === adrs.id ? '2px solid  #dbc359' : '1px solid  #333'}`, borderRadius: '10px'}}>
				        								<input type="radio" id={adrs.id} name="modeOfPayment" value={adrs.id} checked={shippingAddress === adrs.id ? true : false} onChange={(e)=> setShippingAddress(e.target.value)} />
				        								<label for={adrs.id} class="text-dark fs-11">{adrs.company} {adrs.address}</label>
                    								</div>
                    							)}
                							</div>
										}
								
										<div class="form-group">
											<label>Select Dispatch Address</label>
											{address?.map(adrs => 
											<div for={adrs.id} style={{padding: '10px', margin: '10px 0px', border: `${dispatchAddress === adrs.id ? '2px solid  #dbc359' : '1px solid  #333'}`, borderRadius: '10px'}}>
												<input type="radio" id={adrs.id} name="dispatchAddress" value={adrs.id} checked={dispatchAddress === adrs.id ? true : false} onChange={(e)=> setDispatchAddress(e.target.value)} />
												<label for={adrs.id} class="text-dark fs-11">{adrs.company} {adrs.address}</label>
											</div>
											)}
										</div>
										
										<div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">Vehicle Number</label>
												<input class="form-control" name="vNum" value={inputData.vNum} onChange={(e)=>newData(e)} />
									        </div>
										</div>

										<div class="col-md-6">
											<div class="form-group">
                                            	<label class="form-label">E-Way Bill Number</label>
												<input class="form-control" name="evNum" value={inputData.evNum} onChange={(e)=>newData(e)} />
									        </div>
										</div>

										{/* <div class="col-md-12">
											<div class="form-group">
                                            	<label class="form-label">Remarks</label>
												<textarea class="form-control" rows="5" name="remarks" value={inputData.remarks} onChange={(e)=>newData(e)} >{inputData.remarks}</textarea>
									        </div>
										</div> */}

								        

										

								    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-12">
                            <div class="box">
                                <div class="box-body">
								    <h4 class="box-title text-primary mb-0"><i class="ti-save me-15"></i>Challan Details</h4>
								    <hr class="my-15" />
                                    <div class="row">
										<div class="col-md-12">
											<div class="row">
												<div class="col-md-12 mb-3">
													<div class="form-group">
													<label class="form-label">Type</label>
													<div class="input-group" >
														<button class={`btn btn-sm ${inputType === 'crates' ? 'btn-success' : 'btn-secondary'}`} style={{padding: '5px 25px'}} onClick={()=> setinputType('crates')}>Crates</button>
														<button class={`btn btn-sm ${inputType === 'ltr' ? 'btn-success' : 'btn-secondary'}`} style={{padding: '5px 25px'}} onClick={()=> setinputType('ltr')}>Litre</button>
													</div>
													</div>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label class="form-label">Select Product</label>
														<input className="form-control" ref={inputRef} type="text" list="products" placeholder="Search Product" value={selectedProductName} onChange={(e)=> setProduct(e.target.value)} required />
														<datalist id="products">
															{productData?.map((product, index) => 
																<option key={index} value={product.id}>{product.productName}</option>
															)}
														</datalist>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label class="form-label">{inputType === 'crates' ? 'Crates' : 'Litre'}</label>
														<div class="input-group">
															{/* <button type="button" class="btn btn-sm btn-info" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('minus')}}>-</button> */}
															<input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="phone" value={qty} onChange={changeQty} required />
															{/* <button type="button" class="btn btn-sm btn-info" style={{padding: '5px 25px'}} onClick={()=> {changeQtyBtn('plus')}}>+</button> */}
														</div>
													</div>
												</div>

												
												<div class="col-md-2 mt-4">
													{cartError && <p class="text-danger">{error}</p> }
													<button type="button" class="btn btn-sm btn-success  mt-2"  onClick={addCart}>Add Item</button>
												</div>
											</div>
										</div>
										<hr />
										<div class="col-md-12 mt-4">
											{cartItems.length > 0 ?
												<table class="table" style={{borderRight: '1px solid #ddd', }}>
													<thead>
														<tr>
															<th >Product</th>
															<th width="10%">Data Entered</th>
															<th width="10%">Crates</th>
															<th width="10%">Qty</th>
															<th width="15%">L/KG</th>
															<th width="15%">Actions</th>
														</tr>
													</thead>
													<tbody>
														{cartItems?.map((product, index) => 
														<tr>
															<td>{product.name}</td>
															<td>{product.type}</td>
															<td>{parseFloat(product.qty).toFixed(2)}</td>
															<td>{(parseFloat(product.qty) * parseFloat(product.crates)).toFixed(2)}</td>
															<td>{((parseFloat(product.qty) * parseFloat(product.weight) / 1000) * parseFloat(product.crates)).toFixed(2)}</td>
															
															<td class="table-action min-w-100">
																<button class="form-control text-fade hover-primary" onClick={() => removeItem(product.product)}><i class="fa fa-trash"></i></button>
															</td>
														</tr>
														)}
														<tr>
															<th colSpan={2}>Total</th>
															<th>{parseFloat(crates).toFixed(2)}</th>
															<th>{parseFloat(counts).toFixed(2)}</th>
															<th>{parseFloat(weight).toFixed(2)}</th>
														</tr>
														
													</tbody>
												</table>
												:
												<div align="center" class="mt-4 mb-4"> <p>Add Items</p></div>
												}
								    </div>
										<hr />
									<div class="col-md-12">
										<div class="form-group">
                                            <label class="form-label">Remarks</label>
											<textarea class="form-control" rows="5" name="remarks" value={inputData.remarks} onChange={(e)=>newData(e)} >{inputData.remarks}</textarea>
									    </div>
									</div>
									
								</div>
									
							    </div>
							</div>
						</div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
							        <div class="box-footer" align="center">
										{orderError && <p class="text-danger">{errorClient}</p>}
								        <button class="btn btn-primary" onClick={placeOrder} ><i class="fa fa-shopping-cart"></i> Add Challan</button>
							        </div>  
						
					            </div>
						    </div>
						</div>
                     
					</div>
				
				</div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;